module.exports = __webpack_public_path__ + "static/media/selection_white.5081f341.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Layout/selection_white.svg
// module id = 1416
// module chunks = 2